module.exports = __webpack_public_path__ + "img/struct_anatomy.b252e31a.png";